import Vue from 'vue'
import App from './App.vue'

//可以动态修改浏览器标题的插件
//https://blog.csdn.net/wang13679201813/article/details/126639129
import VueWechatTitle from 'vue-wechat-title'

Vue.use(VueWechatTitle);


import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import routerUtil from '@/utils/router_util.js'
import navigationUtil from '@/utils/navigation_util.js'
import 'element-ui/lib/theme-chalk/index.css';
// import '@/styles/site.scss'
import 'amfe-flexible';    // 用于自动设置 rem 基准值
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';
import {utils} from '@/utils/utils.js';

import {http, api} from "@/api/http";
import {request} from "@/api/request";
import VueCookies from 'vue-cookies';

import weui from 'weui.js'
import 'weui'

Vue.prototype.$weui = weui
Vue.prototype.$http = http;
Vue.prototype.$api = api;
Vue.prototype.$request = request;
Vue.prototype.$navigation = navigationUtil;
Vue.prototype.$utils = utils;

console.log('环境：', process.env.NODE_ENV)
import Vconsole from 'vconsole';

if (process.env.NODE_ENV !== 'production' || utils.getQueryVariable('isConsole')) {       // 判断环境
    const vConsole = new Vconsole;
}

const $$loadingClass = {
    l: null,
    loading() {
        this.l = layer.load(2)
        return this;
    },
    close() {
        layer.close(this.l);
    }
}
// 轻量级的Loading，不会有遮罩
// 使用该对象取代Vue.prototype.$layer
Vue.prototype.$$loading = function () {
    let ins = Object.create($$loadingClass);
    ins.loading();
    return ins;
};

//基于layer-ui的loading
Vue.prototype.$layer = {
    loading(style = 2) {
        return layer.load(style);
    },
    closeLoading(loadingInstance) {
        layer.close(loadingInstance);
    }
};
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueLoaders);
Vue.use(VueCookies);

checkIsAuthorized((res) => {
    router.beforeEach((to, from, next) => {
        next();
    });
    setRouters(res);
    
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
});

/**
 * 动态设置路由
 * @param {any} res
 */
function setRouters(res) {
    let routers = routerUtil.convert(res.data.rotues);
    console.log('# routers：', routers)
    for (let i = 0; i < routers.length; i++) {
        router.addRoute(routers[i]);
    }
    
    router.addRoute({
        path: '/:corpId/NotFound',
        name: 'NotFound',
        component: () => import('@/views/NotFound/Index.vue')
    });
    
    router.addRoute({
        path: '/:corpId/AccessDenied1',
        name: 'AccessDenied1',
        component: () => import('@/views/Common/AccessDenied.vue')
    });
    
    router.addRoute({
        path: '/:corpId/AccessDenied2',
        name: 'AccessDenied2',
        component: () => import('@/views/Common/AccessDenied2.vue')
    });
    
    // router.addRoute({
    //     path: "/:corpId/*", // 此处需特别注意置于最底部，重定向
    //     redirect: "/:corpId/NotFound"
    // });
}

/**
 * 进入single page application之前检测是否已授权
 * window.location.href = https://localhost:44327/1/Home
 * window.location.origin = https://localhost:44327
 * window.location.pathname = /1/Home
 * @constructor
 */
function checkIsAuthorized(callback) {
    //* 判断重定向次数，防止陷入授权死循环 */
    let sessionKey = "checkIsAuthorized";
    let checkIsAuthorizedValue = sessionStorage.getItem(sessionKey);
    if (checkIsAuthorizedValue == undefined || checkIsAuthorizedValue == null) {
        checkIsAuthorizedValue = 0;
    }
    if (checkIsAuthorizedValue > 1) {
        sessionStorage.removeItem(sessionKey);
        alert("idsrv4授权繁忙，请稍后重试！");
        return;
    }
    
    
    let that = this;
    console.log('检查idsrv4授权信息...');
    let xhr = new XMLHttpRequest();
    let url = api.build("/Client/Check");
    console.log('检查授权URL：', url);
    xhr.open("GET", url);
    xhr.setRequestHeader("x-requested-with", "XMLHttpRequest");
    xhr.onload = () => {
        // console.log(11,xhr.responseText)
        let res = JSON.parse(xhr.responseText);
        console.log('check result: ', res);
        if (res == null) {
            sessionStorage.removeItem(sessionKey);
            console.error('检查idsrv4授权信息错误', xhr);
            alert(xhr.responseText)
        }
        else if (res.code === 401) {
            sessionStorage.setItem(sessionKey, parseInt(checkIsAuthorizedValue) + 1);
            window.location = api.build('/Client/RedirectTo?redirectUrl=' + encodeURIComponent(window.location.href));
        }
        else if (res !== null && res.code === 200) {
            sessionStorage.removeItem(sessionKey);
            Vue.prototype.$work_ctx = res.data;
            navigationUtil.Router.set(res.data.rotues);
            console.log('this.$work_ctx=>', Vue.prototype.$work_ctx)
            callback(res);
        }
        else {
            sessionStorage.removeItem(sessionKey);
            console.error('检查idsrv4授权信息错误', xhr);
            alert(res.message)
        }
    };
    xhr.send();
}